import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

enum PolicyType {
  system = '1',
  custom = '2',
}

const nameConfig = {
  system: new Map([
    [Locale.ja, 'ProPlus管理'],
    [Locale.en, 'ProPlus Managed'],
  ]),
  custom: new Map([
    [Locale.ja, 'ユーザー管理'],
    [Locale.en, 'User Managed'],
  ]),
};

const toEnum = rawValueToEnum(PolicyType, PolicyType.system);
const toDisplay = enumToName(PolicyType, nameConfig);
const toDisplayWithPrefix = enumToName(PolicyType, nameConfig, { prefix: true });

export const policyType = {
  enum: PolicyType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { PolicyType };
